import { PeopleAlt, Settings, Dashboard } from "@mui/icons-material";
// LibraryBooks

export const HOME = "HOME";
export const APPOINTMENTS = "APPOINTMENTS";
export const EHR = "EHR";
export const VITALS = "VITALS";
export const DOCUMENTS = "DOCUMENTS";
export const TASKS = "TASKS";
export const PATIENT = "PATIENTS";
export const SETTINGS = "SETTINGS";
export const ME = "ME";
export const STORE = "STORE";
export const CHECKOUT = "CHECKOUT";
export const SUPPORT = "SUPPORT";
export const PAYMENT_SUCCESS="PAYMENT-SUCCESS"

export const ROUTER_OBJECT = [
  {
    label: "Dashboard",
    Icon: Dashboard,
    identifier: HOME,
    path: "/home/dashboard",
    className: "step-1 step-10",
  },
  {
    label: "Patients",
    Icon: PeopleAlt,
    identifier: PATIENT,
    path: "/patients/list",
    className: "step-2",
  },
  {
    label: "Settings",
    Icon: Settings,
    identifier: SETTINGS,
    path: "/settings/me",
    className: "step-3",
  },
  //   {
  //     label: "tooltips.APPOINTMENTS",
  //     Icon: CalendarMonth,
  //     identifier: APPOINTMENTS,
  //     // path: '/appointments/upcoming',
  //     path: "/appointments/recent",
  //     className: "step-3",
  //   },
  //   {
  //     label: "tooltips.EHR",
  //     Icon: AddCircle,
  //     identifier: EHR,
  //     path: "/ehr/personal_info",
  //     className: "step-4",
  //   },
  //   {
  //     label: "ehr.tabs.VITALS",
  //     Icon: MonitorHeart,
  //     identifier: VITALS,
  //     path: "/vitals/view",
  //     className: "step-5",
  //   },
  //   {
  //     label: "documents.DOCUMENTS",
  //     Icon: Description,
  //     identifier: DOCUMENTS,
  //     path: "/documents/view",
  //     className: "step-6",
  //   },
  //   {
  //     label: "tasks.TASKS",
  //     Icon: AssignmentTurnedIn,
  //     identifier: TASKS,
  //     path: "/tasks/requested",
  //     className: "step-7",
  //   },
];

export const getPathNames = () => {
  return window.location.pathname.split("/");
};
